<template>
  <div>
    <div v-if="showLoading" class="center">
      <lottie
        :options="defaultOptionsSplashScreen"
        :height="300"
        :width="300"
        @animCreated="handleAnimationSplashScreen"
      />
    </div>

    <div v-else>
      <headerSection></headerSection>

      <div class="reward-page" :style="pageBackgroundStyle">
        <div class="container reward-shell">
          <section class="reward-hero">
            <div class="reward-hero__panel">
              <p class="reward-hero__eyebrow">
                <i class="fas fa-ticket"></i>
                Lucky Number
              </p>
              <h1 class="reward-hero__title">แทงหวยไม่ยั้ง</h1>
              <p class="reward-hero__desc">
                ทุกยอดฝาก 100 บาท รับทันที 1 สิทธิ์สำหรับเลขท้าย 2 ตัวล่างรัฐบาล
                เฉพาะวันที่ระบบเปิดรับสิทธิ์ตามเงื่อนไขกิจกรรม
              </p>

              <div class="reward-chip-row">
                <span class="reward-chip">
                  <i class="fas fa-bolt"></i>
                  ใช้ไป {{ countQtyLabel }}/{{ qtyLabel }} สิทธิ์
                </span>
                <span :class="['reward-chip', isShow ? 'is-success' : 'is-danger']">
                  <i class="fas" :class="isShow ? 'fa-check-circle' : 'fa-times-circle'"></i>
                  {{ isShow ? 'เปิดรับสิทธิ์' : 'ปิดรับชั่วคราว' }}
                </span>
                <span class="reward-chip is-muted">
                  <i class="fas fa-money-bill-wave"></i>
                  ฝากครบทุก 100 บาท = 1 สิทธิ์
                </span>
              </div>
            </div>

            <aside class="reward-side-panel">
              <h2 class="reward-side-panel__title">สรุปสิทธิ์ของคุณ</h2>

              <div class="reward-kv-list">
                <div class="reward-kv">
                  <span class="reward-kv__label">สิทธิ์ทั้งหมด</span>
                  <span class="reward-kv__value">{{ qtyLabel }}</span>
                </div>
                <div class="reward-kv">
                  <span class="reward-kv__label">เลือกแล้ว</span>
                  <span class="reward-kv__value">{{ countQtyLabel }}</span>
                </div>
                <div class="reward-kv">
                  <span class="reward-kv__label">สิทธิ์คงเหลือ</span>
                  <span class="reward-kv__value">{{ remainingQtyLabel }}</span>
                </div>
              </div>

              <div class="reward-side-panel__body" style="margin-top: 18px;">
                เลขที่เลือกไว้
              </div>

              <div class="reward-pill-list">
                <span v-for="number in selectedNumbers" :key="number" class="reward-pill">
                  {{ number }}
                </span>
                <span v-if="!selectedNumbers.length" class="reward-badge is-muted">
                  ยังไม่ได้เลือกเลข
                </span>
              </div>

              <div style="margin-top: 18px;">
                <button
                  type="button"
                  :class="['reward-button', { 'is-disabled': !canConfirm }]"
                  :disabled="!canConfirm"
                  @click="confirm()"
                >
                  <i class="fas fa-check"></i>
                  {{ buttonLabel }}
                </button>
              </div>
            </aside>
          </section>

          <section class="reward-section">
            <div class="reward-section__header">
              <div>
                <h2 class="reward-section__title">เลือกเลข 00 - 99</h2>
                <p class="reward-section__subtext">
                  แตะเพื่อเลือกหรือยกเลิกเลขได้ทันที ระบบจะจำจำนวนสิทธิ์ตามยอดฝากของคุณ
                </p>
              </div>
            </div>

            <div class="reward-number-grid">
              <button
                v-for="num in numberOptions"
                :key="num"
                type="button"
                :class="['reward-number-button', {
                  'is-selected': !!huays[num],
                  'is-disabled': isButtonDisabled(num)
                }]"
                :disabled="isButtonDisabled(num)"
                @click="selectNumber(num)"
              >
                {{ num }}
              </button>
            </div>

            <div class="reward-action-row">
              <button
                type="button"
                :class="['reward-button', { 'is-disabled': !canConfirm }]"
                :disabled="!canConfirm"
                @click="confirm()"
              >
                <i class="fas fa-check"></i>
                {{ buttonLabel }}
              </button>
            </div>
          </section>

          <section class="reward-section reward-section--compact">
            <div class="reward-note-list">
              <div class="reward-note">
                <i class="fas fa-info-circle"></i>
                <div>
                  <strong>เงื่อนไขสิทธิ์</strong>
                  <span>ทุกยอดฝาก 100 บาท รับ 1 สิทธิ์ในวันที่กิจกรรมเปิดรับเท่านั้น</span>
                </div>
              </div>
              <div class="reward-note">
                <i class="fas fa-trophy"></i>
                <div>
                  <strong>รางวัล</strong>
                  <span>แทงถูกเลขท้าย 2 ตัวล่างรัฐบาล รับฟรี 500 เครดิตตามเงื่อนไขกิจกรรม</span>
                </div>
              </div>
              <div class="reward-note">
                <i class="fas fa-shield-alt"></i>
                <div>
                  <strong>ข้อกำหนด</strong>
                  <span>หากตรวจพบการโกงหรือทุจริต ระบบจะตัดสิทธิ์ทันทีตามประกาศของเว็บไซต์</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <footerSection></footerSection>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'
import moment from 'moment-timezone'

export default {
  name: 'Gift',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
      const _user = JSON.parse(user)
      this.$store.dispatch('user/setUser', _user).then(async () => {
        const huay = (await firebase.database().ref('/huay').once('value')).val() || []
        const dateHuay = []
        for (const x in huay) {
          dateHuay.push(Number(huay[x]))
        }
        if (dateHuay.includes(Number(moment().tz('Asia/Bangkok').format('D')))) {
          if (Number(moment().tz('Asia/Bangkok').format('H') + '' + moment().tz('Asia/Bangkok').format('mm')) <= 1520) {
            this.calculate()
            this.isShow = true
          } else {
            this.calculate()
          }
        } else {
          this.QTY = 0
          this.countQTY = 0
        }
      }).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
    }
    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    pageBackgroundStyle () {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(7, 13, 28, 0.32) 0%, rgba(7, 13, 28, 0.85) 100%), url(${require('../assets/images/Shiba-BG.jpg')})`
      }
    },
    numberOptions () {
      return Array.from({ length: 100 }, (_, index) => String(index).padStart(2, '0'))
    },
    selectedNumbers () {
      return Object.keys(this.huays)
        .filter(key => this.huays[key])
        .sort((a, b) => Number(a) - Number(b))
    },
    qtyLabel () {
      return typeof this.QTY === 'number' ? this.QTY : 'loading'
    },
    countQtyLabel () {
      return typeof this.countQTY === 'number' ? this.countQTY : 'loading'
    },
    remainingQty () {
      if (typeof this.QTY !== 'number' || typeof this.countQTY !== 'number') return 0
      return Math.max(this.QTY - this.countQTY, 0)
    },
    remainingQtyLabel () {
      return typeof this.QTY === 'number' && typeof this.countQTY === 'number' ? this.remainingQty : 'loading'
    },
    canConfirm () {
      return this.isShow &&
        !this.isDisabled &&
        typeof this.QTY === 'number' &&
        this.QTY > 0 &&
        typeof this.countQTY === 'number' &&
        this.countQTY <= this.QTY
    }
  },
  mounted () {
    this.animSplashScreen.play()
    setTimeout(() => {
      this.showLoading = false
      this.animSplashScreen.stop()
    }, 3500)
  },
  data () {
    return {
      isShow: false,
      huays: {},
      showLoading: true,
      buttonLabel: 'ยืนยันแทงหวย',
      defaultOptionsSplashScreen: null,
      isDisabled: false,
      QTY: 'loading',
      countQTY: 'loading'
    }
  },
  methods: {
    calculate () {
      this.huays = {}
      this.countQTY = 0
      firebase.firestore().collection('krungsri').where('date', '>=', moment().tz('Asia/Bangkok').format('YYYY-MM-DD') + ' 00:00:00').where('type', '==', 'ฝาก').where('status', '==', 'ดำเนินการแล้ว').where('userkey', '==', this.user.key).get().then((snapshot) => {
        let deposit = 0
        snapshot.forEach((doc) => {
          deposit += Number(doc.data().qty.toString().replace(',', ''))
        })
        const qty = Math.floor(deposit / 100)
        this.QTY = qty
        firebase.firestore().collection('huays').doc(this.user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).get().then((doc) => {
          if (doc.exists && doc.data().huays) {
            const selected = {}
            doc.data().huays.forEach((num) => {
              selected[num] = true
            })
            this.huays = selected
            this.countQTY = doc.data().huays.length
          } else {
            this.huays = {}
            this.countQTY = 0
          }
        })
      })
    },
    isButtonDisabled (num) {
      if (!this.isShow || typeof this.QTY !== 'number' || typeof this.countQTY !== 'number') return true
      return this.remainingQty <= 0 && !this.huays[num]
    },
    selectNumber (num) {
      if (typeof this.countQTY === 'number' && typeof this.QTY === 'number' && this.isShow) {
        if (this.huays[num]) {
          this.$delete(this.huays, num)
          this.countQTY--
        } else if (this.QTY > this.countQTY) {
          this.$set(this.huays, num, true)
          this.countQTY++
        }
      }
    },
    async confirm () {
      if (Object.keys(this.huays).length <= this.QTY && this.QTY > 0) {
        this.buttonLabel = 'loading...'
        this.isDisabled = true
        const huays = []
        for (const x in this.huays) {
          if (this.huays[x]) {
            huays.push(x)
          }
        }
        firebase.firestore().collection('huays').doc(this.user.key + '-' + moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).set({
          huays,
          userkey: this.user.key,
          updatetime: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
          date: moment().tz('Asia/Bangkok').format('YYYY-MM-DD'),
          code: this.user.code
        }).then(async () => {
          this.isDisabled = false
          this.buttonLabel = 'ยืนยันแทงหวย'
          this.$confirm(
            {
              message: 'แทงหวยเรียบร้อยแล้วค่ะ 😘',
              button: {
                yes: 'OK'
              },
              callback: confirm => {
                if (confirm) {
                  return true
                }
              }
            }
          )
        })
      } else {
        alert('โปรดตรวจสอบสิทธิ์จำนวนที่แทง')
      }
    },
    handleAnimationSplashScreen (anim) {
      this.animSplashScreen = anim
    }
  }
}
</script>

<style scoped>
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
